import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { Observable } from 'rxjs';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { API_SELLER_OFFICE_V2 } from '../constants';
import { Seller } from '../models';

@Injectable({
  providedIn: 'root',
})
export class SellerService {
  constructor(private http: HttpClient, @Optional() @Inject(REQUEST) private request: any) {}

  getSeller(organizationId: string): Observable<Seller> {
    const url = `${API_SELLER_OFFICE_V2}/public/${getCountryDomainCode(this.request)}/organizations/${organizationId}`;
    return this.http.get<Seller>(url);
  }
}
